import React, { useState } from 'react';
import './index.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import Schedule from './pages/Schedule';
import IncidentLog from './pages/IncidentLog';
import {
  MRQLog, VOLog, CostTracker, DocumentLog, IPCLog, DailyReports, Settings,
} from './pages/OtherPages';

function AppShell() {
  const { user } = useAuth();
  const [page, setPage] = useState('dashboard');

  if (!user) return <Login />;

  const PAGE_MAP = {
    dashboard: <Dashboard setPage={setPage} />,
    projects:  <Projects setPage={setPage} />,
    schedule:  <Schedule />,
    incidents: <IncidentLog />,
    mrq:       <MRQLog />,
    vos:       <VOLog />,
    costs:     <CostTracker />,
    docs:      <DocumentLog />,
    ipcs:      <IPCLog />,
    daily:     <DailyReports />,
    settings:  <Settings />,
  };

  return (
    <div className="app-shell">
      <Sidebar page={page} setPage={setPage} />
      <main className="main-area">
        {PAGE_MAP[page] || PAGE_MAP['dashboard']}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <AppShell />
      </DataProvider>
    </AuthProvider>
  );
}
